/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Which virtual tokens a competition accepts as entry (REQUEST shape). Whether a token may be spent at all is declared by EntryFeeConfig.permittedTenders; this declares which ones qualify.
 * @export
 * @interface TokenEntryConfig
 */
export interface TokenEntryConfig {
    /**
     * NftTracker ids whose tokens are accepted. The authoring path — an explicit list, so a competition can take several denominations.
     * @type {Array<string>}
     * @memberof TokenEntryConfig
     */
    acceptedNftTrackerIds?: Array<string>;
    /**
     * Legacy scope — any tracker in this grouping is accepted. Cannot identify which denomination was burned, so prefer acceptedNftTrackerIds.
     * @type {string}
     * @memberof TokenEntryConfig
     */
    acceptedNftGroupingId?: string;
    /**
     * Legacy scope — accept any competition-eligible virtual token the player holds.
     * @type {boolean}
     * @memberof TokenEntryConfig
     */
    acceptsUniversalToken: boolean;
}

/**
 * Check if a given object implements the TokenEntryConfig interface.
 */
export function instanceOfTokenEntryConfig(value: object): value is TokenEntryConfig {
    if (!('acceptsUniversalToken' in value) || value['acceptsUniversalToken'] === undefined) return false;
    return true;
}

export function TokenEntryConfigFromJSON(json: any): TokenEntryConfig {
    return TokenEntryConfigFromJSONTyped(json, false);
}

export function TokenEntryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenEntryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedNftTrackerIds': json['acceptedNftTrackerIds'] == null ? undefined : json['acceptedNftTrackerIds'],
        'acceptedNftGroupingId': json['acceptedNftGroupingId'] == null ? undefined : json['acceptedNftGroupingId'],
        'acceptsUniversalToken': json['acceptsUniversalToken'],
    };
}

export function TokenEntryConfigToJSON(json: any): TokenEntryConfig {
    return TokenEntryConfigToJSONTyped(json, false);
}

export function TokenEntryConfigToJSONTyped(value?: TokenEntryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'acceptedNftTrackerIds': value['acceptedNftTrackerIds'],
        'acceptedNftGroupingId': value['acceptedNftGroupingId'],
        'acceptsUniversalToken': value['acceptsUniversalToken'],
    };
}

